import { Link } from 'react-router-dom';
import { Heart, Mail, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_0411bc8a-f562-425b-a1dd-f5f58614235d/artifacts/xk13ab9h_image.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#272926] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & Mission */}
          <div className="md:col-span-2">
            <img 
              src={LOGO_URL} 
              alt="Players Health Foundation" 
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-zinc-400 leading-relaxed max-w-md">
              Protecting kids. Powering possibilities. We are a catalyst to protect athletes and open doors to the power of sport for all.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4 text-zinc-300">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/about" 
                  className="text-zinc-400 hover:text-[#7B71FA] transition-colors"
                  data-testid="footer-link-about"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/programs" 
                  className="text-zinc-400 hover:text-[#7B71FA] transition-colors"
                  data-testid="footer-link-programs"
                >
                  Programs
                </Link>
              </li>
              <li>
                <Link 
                  to="/grants" 
                  className="text-zinc-400 hover:text-[#7B71FA] transition-colors"
                  data-testid="footer-link-grants"
                >
                  Grants
                </Link>
              </li>
              <li>
                <Link 
                  to="/newsroom" 
                  className="text-zinc-400 hover:text-[#7B71FA] transition-colors"
                  data-testid="footer-link-newsroom"
                >
                  Newsroom
                </Link>
              </li>
              <li>
                <Link 
                  to="/get-involved" 
                  className="text-zinc-400 hover:text-[#7B71FA] transition-colors"
                  data-testid="footer-link-get-involved"
                >
                  Get Involved
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-zinc-400 hover:text-[#7B71FA] transition-colors"
                  data-testid="footer-link-contact"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4 text-zinc-300">
              Get In Touch
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center text-zinc-400">
                <Mail className="h-4 w-4 mr-2 text-[#7B71FA]" />
                <a 
                  href="mailto:foundation@playershealth.com" 
                  className="hover:text-[#7B71FA] transition-colors"
                  data-testid="footer-email"
                >
                  foundation@playershealth.com
                </a>
              </li>
              <li className="flex items-start text-zinc-400">
                <MapPin className="h-4 w-4 mr-2 mt-1 text-[#7B71FA] flex-shrink-0" />
                <span>Minneapolis, MN</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-zinc-700 flex flex-col md:flex-row items-center justify-between">
          <p className="text-zinc-500 text-sm">
            &copy; {currentYear} Players Health Foundation. All rights reserved.
          </p>
          <p className="text-zinc-500 text-sm flex items-center mt-4 md:mt-0">
            Made with <Heart className="h-4 w-4 mx-1 text-[#5B4FF9]" /> for youth athletes everywhere
          </p>
        </div>
      </div>
    </footer>
  );
};
